import { render, staticRenderFns } from "./DepositDetails.vue?vue&type=template&id=4d32da50"
import script from "./DepositDetails.vue?vue&type=script&lang=js"
export * from "./DepositDetails.vue?vue&type=script&lang=js"
import style0 from "./DepositDetails.vue?vue&type=style&index=0&id=4d32da50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports